import React, { useMemo } from 'react';
import { testId } from '../../../../utils/testIds';
import { useFormContext } from 'react-hook-form';
import CalendarPicker from '../CalendarPicker';
import { normalizeToIso, formatDateForDisplay, getDateConstraints } from '../../utils/dateUtils';
import { RENDER_MODE } from '../../constants';

function DateField({ config, value, onChange, onBlur, disabled, required, error, renderMode }) {
  const { watch } = useFormContext();
  const minDateFieldKey = useMemo(
    () => config.validation?.find(r => r.rule === 'minDateField')?.value ?? null,
    [config.validation]
  );
  const referencedDateValue = minDateFieldKey ? watch(minDateFieldKey) : undefined;

  const { maxDate, minDate } = useMemo(
    () => getDateConstraints(config.validation ?? [], referencedDateValue),
    [config.validation, referencedDateValue]
  );

  if (renderMode === RENDER_MODE.CARD || renderMode === RENDER_MODE.GRID) {
    return (
      <span className="field-engine-date-value">
        {formatDateForDisplay(value) || <span className="field-engine-empty">—</span>}
      </span>
    );
  }

  return (
    <CalendarPicker
      dataTestPrefix={testId('field', config.fieldKey)}
      value={normalizeToIso(value)}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      required={required}
      minDate={minDate}
      maxDate={maxDate}
      placeholder={config.fieldSettings?.placeholder ?? config.label ?? ''}
      error={error}
    />
  );
}

export default DateField;
